(() => {
  const nav = document.querySelector('[data-gv-shirt-nav]');
  if (!nav || window.gvShirtCategoriesInitialized) return;
  window.gvShirtCategoriesInitialized = true;
  const allowed = new Set(['all', 'oversize', 'regular', 'polo', 'beisboleras']);
  let selected = new URL(location.href).searchParams.get('gv_fit') || 'all';
  if (!allowed.has(selected)) selected = 'all';
  let lastGrid;
  function apply() {
    const grid = document.getElementById('product-grid');
    const cards = grid ? Array.from(grid.querySelectorAll('[data-gv-shirt-category]')) : [];
    let count = 0;
    cards.forEach(card => {
      card.hidden = selected !== 'all' && card.dataset.gvShirtCategory !== selected;
      if (!card.hidden) count++;
    });
    nav.querySelectorAll('[data-gv-fit]').forEach(link => {
      const active = link.dataset.gvFit === selected;
      link.classList.toggle('is-active', active);
      if (active) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
    const counter = document.querySelector('[data-gv-shirt-count]');
    if (counter) counter.textContent = `${count} ${count === 1 ? counter.dataset.singleLabel : counter.dataset.countLabel}`;
    document.querySelectorAll('.facet-checkbox__text').forEach(node => {
      Array.from(node.childNodes).filter(child => child.nodeType === 3).forEach(child => {
        child.textContent = child.textContent.replace(/\s*\(\d+\)/g, '');
      });
    });
    document.querySelectorAll('.facets__label .visually-hidden, .mobile-facets__label .visually-hidden').forEach(node => {
      const clean = node.textContent.replace(/\s*\(\d+\s+[^)]+\)/g, '').trim();
      if (node.textContent.trim() !== clean) node.textContent = clean;
    });
    const empty = document.querySelector('[data-gv-shirt-empty]');
    if (empty) empty.hidden = count !== 0 || selected === 'all';
    ['ProductCount', 'ProductCountDesktop'].forEach(id => {
      const node = document.getElementById(id);
      if (node && counter) node.textContent = counter.textContent;
    });
    const url = new URL(location.href);
    if (selected === 'all') url.searchParams.delete('gv_fit');
    else url.searchParams.set('gv_fit', selected);
    history.replaceState(history.state, '', url);
    lastGrid = grid;
  }
  apply();
  const container = document.getElementById('ProductGridContainer');
  if (container) new MutationObserver(() => {
    const grid = document.getElementById('product-grid');
    if (grid !== lastGrid) apply();
  }).observe(container, { childList: true, subtree: true });
  window.addEventListener('popstate', () => {
    const value = new URL(location.href).searchParams.get('gv_fit') || 'all';
    selected = allowed.has(value) ? value : 'all';
    apply();
  });
})();
